import Layout from '@/layout/layout'

const RecallOrderRouter = {
    path: '/RecallOrder',
    component: Layout,
    redirect: 'noRedirect',
    name: '订单列表',
    children: [
        {
            path: 'index',
            component: () => import('@/views/RecallOrder/index'),
            name: '回收订单',
            meta: {title: '回收订单', noCache: true}
        },
        {
            path: 'Details',
            component: () => import('@/views/RecallOrder/Details'),
            name: '订单详情',
            meta: {title: '订单详情', noCache: true}
        },
        {
            path: 'difference',
            component: () => import('@/views/RecallOrder/difference'),
            name: '差异订单',
            meta: {title: '差异订单', noCache: true}
        },
        {
            path: '/RecallOrder/difference/process',
            component: () => import('@/views/RecallOrder/difference/process.vue'),
            name: '差异详情',
            meta: {title: '差异详情', noCache: true}
        },
        {
            path: 'failedBidorder',
            component: () => import('@/views/RecallOrder/failedBidorder/index'),
            name: '竞价失败订单',
            meta: {title: '竞价失败订单', noCache: true}
        },
        {
            path: 'rejuectOrder',
            component: () => import('@/views/RecallOrder/rejuectOrder/index'),
            name: '报价单',
            meta: {title: '报价单', noCache: true}
        },
        // {
        //     path: 'referencePrice',
        //     component: () => import('@/views/RecallOrder/referencePrice/index'),
        //     name: '参考价',
        //     meta: {title: '参考价', noCache: true}
        // },
        {
            path: 'unsettledOrder',
            component: () => import('@/views/unsettledOrder/index'),
            name: '未成交订单',
            meta: {title: '未成交订单', noCache: true}
        },
        {
            path: 'autoOrder',
            component: () => import('@/views/RecallOrder/autoOrder/index'),
            name: '自动报价订单',
            meta: {title: '自动报价订单', noCache: true}
        },
                    {
            path: 'imageRecog',
            component: () => import('@/views/RecallOrder/imageRecog/index'),
            name: '智能报价单',
            meta: {title: '智能报价单', noCache: true}
        },
    ]
}

export default RecallOrderRouter
